import type { PropsWithChildren } from "react";

export function Skeleton({ className, children }: PropsWithChildren<{ className?: string }>) {
  return <div className={`${className} animate-pulse rounded-rounded bg-bg_light`}>{children}</div>;
}
